import React from 'react';
import {DialogTrigger, Dialog, ActionButton, Heading, Divider, Content, Text, Button, ButtonGroup, Tooltip, TooltipTrigger} from '@adobe/react-spectrum'

function StatusMessage({...properties}) {

    return (
        <TooltipTrigger isOpen={properties.showError}>
        <ActionButton position="absolute" right={0} id='showStatusMessage' isQuiet={true} isDisabled={true}></ActionButton>
        <Tooltip variant='negative' placement='bottom' marginTop='size-200' showIcon={true} width={'size-2500'} height={'size-2000'}>
            <Heading>Too Many Words!</Heading>
            <Text>
                The text you have selected will not fit within the remaining word limit. Remove or edit your existing highlights to highlight this text.
            </Text>
        </Tooltip>
        </TooltipTrigger>
    );
}

export default StatusMessage;